var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "noData" }, [
      _c("img", { attrs: { src: require("@/assets/img/error.png"), alt: "" } }),
      _c("p", [_vm._v("正在查询")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }